import { buildRequestParams } from '../utils';
import { API } from './api';
/**
 * Organization API.
 * @author leonardo.couto
 */
export class OrganizationAPI extends API {
    /**
     * Retrieves the public settings of the organization.
     * @param args - Arguments for the request.
     * @returns Public settings of the organization.
     */
    async getConfigs(args) {
        const requestParams = buildRequestParams(Object.assign(Object.assign({}, args), { methodIdentifier: '_organizationConfigs' }));
        requestParams.public = true;
        const orgConfigRequest = this.restService.get(requestParams);
        const appInfoRequest = this.restService.get({
            addBaseUrl: false,
            url: this.restService.config.baseUrl.replace('/api/1', '/api/sys/rest/appInfo'),
            public: true,
        });
        const [orgConfigsResponse, apiInfoResponse] = await Promise.all([orgConfigRequest, appInfoRequest]);
        if (orgConfigsResponse.error) {
            return orgConfigsResponse;
        }
        if (apiInfoResponse.error) {
            return apiInfoResponse;
        }
        orgConfigsResponse.data.version = apiInfoResponse.data.version;
        return orgConfigsResponse;
    }
    /**
     * Gets the permalink of an object.
     * @param args - Arguments for the request.
     * @returns Permalink of the object.
     */
    getPermalink(args) {
        const requestParams = buildRequestParams({
            packageIdentifier: '_system',
            classIdentifier: '_organization',
            methodIdentifier: '_get',
            queryParams: {
                _id: args._id,
                _classId: args._classId,
                isDraft: args.isDraft,
                appIdentifier: this.restService.config.app,
            },
        });
        return this.restService.get(requestParams);
    }
    /**
     * Gets the URL of the organization's logo.
     * @param [org] - Identifier of the organization.
     * @returns URL of the organization's logo.
     */
    getLogoUrl(org) {
        const { org: defaultOrg, baseUrl, app } = this.restService.config;
        const logoUrl = new URL(`${app}/_organizationConfigs/${org !== null && org !== void 0 ? org : defaultOrg}/ws-logo`, baseUrl);
        return logoUrl.href;
    }
}
